module.exports = __webpack_public_path__ + "img/concrete_greige_ba_list.fdb97987.jpg";